import { BillReceiverType } from "../../../modules/company/admin/organization/userGroups/userGroupsTypes"
import { BillReceiverEndpointMS, BillReceiverTypeMS } from "../createOrder/createOrderTypes"

import {
    BillReceiversFormValuesType,
    BillReceiversType,
    CountryCode,
    isPrivateCompanyDetails,
    isPrivatePersonDetails,
    isPublicInstitutionDetails,
    SendInvoiceCompany,
} from "./billReceiverTypes"
import { CreateBillReceiversParams } from "./billReceiverApi"
import { BillReceiverAddress } from "./billReceiverTypes"

function sendInvoiceCompanyToEndpointMS(company: SendInvoiceCompany): BillReceiverEndpointMS {
    switch (company.invoiceType) {
        case BillReceiverType.EAN_NUMBER:
            return {
                type: BillReceiverTypeMS.EAN_NUMBER,
                ean: company.search,
            }
        case BillReceiverType.EMAIL_ADDRESS:
            return {
                type: BillReceiverTypeMS.EMAIL_ADDRESS,
                email: company.search,
            }
    }
}

export function billReceiverToApi(
    formValues: BillReceiversFormValuesType,
    billType: BillReceiversType | null,
    endpointValue?: string,
    endpointType?: SendInvoiceCompany,
    userId?: number,
): CreateBillReceiversParams | undefined {
    const address: BillReceiverAddress = {
        countryCode: formValues.country === CountryCode.DA ? "DK" : formValues.country,
        postalCode: formValues.postalCode,
        city: formValues.city,
        addressLines: [formValues.addressLine1],
    }

    if (formValues.addressLine2) {
        address.addressLines.push(formValues.addressLine2)
    }
    const onBehalfOf = userId
        ? {
              onBehalfOf: {
                  userId: userId,
              },
          }
        : {}
    const baseBillReceiver = {
        debitorNo: formValues.debtorNumber,
        address,
        isActive: true, // Assuming newly created bill receivers are active by default
        ...onBehalfOf,
    }

    switch (billType) {
        case BillReceiversType.PRIVATE_PERSON:
            if (isPrivatePersonDetails(formValues)) {
                return {
                    billReceiver: {
                        ...baseBillReceiver,
                        endpoint: {
                            type: BillReceiverTypeMS.EMAIL_ADDRESS,
                            email: endpointValue || "",
                        },
                        type: BillReceiversType.PRIVATE_PERSON,
                        name: formValues.name,
                    },
                }
            }
            return

        case BillReceiversType.PUBLIC_INSTITUTION:
            if (isPublicInstitutionDetails(formValues)) {
                return {
                    billReceiver: {
                        ...baseBillReceiver,
                        type: BillReceiversType.PUBLIC_INSTITUTION,
                        name: formValues.institutionName,
                        endpoint: {
                            type: BillReceiverTypeMS.EAN_NUMBER,
                            ean: endpointValue || "",
                        },
                        ...(formValues.vatnumber ? { vatnumber: formValues.vatnumber } : {}),
                        contactDetails: {
                            name: formValues.contactPerson,
                            email: formValues.email,
                            phoneNumber: formValues.telephone,
                        },
                    },
                }
            }
            return

        case BillReceiversType.PRIVATE_COMPANY:
            if (isPrivateCompanyDetails(formValues)) {
                if (!endpointType) {
                    return
                }

                return {
                    billReceiver: {
                        ...baseBillReceiver,
                        type: BillReceiversType.PRIVATE_COMPANY,
                        name: formValues.companyName,
                        endpoint: sendInvoiceCompanyToEndpointMS(endpointType),
                        vatnumber: endpointValue,
                        contactDetails: {
                            name: formValues.contactPerson,
                            email: formValues.email,
                            phoneNumber: formValues.telephone,
                        },
                    },
                }
            }
            return

        default:
            throw new Error(`Unknown bill receiver type: ${billType}`)
    }
}
